(function () {
  var $opt = {
    toSlide: 850,
  };

  function slidePDP() {
    var self = this;
    this.isSlide = false;
    this.currentPanzzom = null;
    this.init = function () {
      this.startSlide();
    };

    this.startSlide = function () {
      if ($(window).outerWidth(true) > $opt.toSlide) {
        self.isSlide = false;
      } else {
        self.isSlide = true;
      }

      if ('slick' in $.fn && typeof $.fn.slick === 'function') {
        // $('.product_media').on('init', function(event, slick){
        //     self.setZoom('0',self.isSlide);
        // });
        //
        // $('.product_media').on('beforeChange', function(event, slick, currentSlide, nextSlide){
        //     self.currentPanzzom.destroy();
        //     self.setZoom(nextSlide,self.isSlide);
        // });

        $('.product_media').slick({
          accessibility: true,
          infinite: true,
          slide: '.isSlider',
          slidesToScroll: 1,
          dots: true,
          arrows: false,
          slidesToShow: 1,
          mobileFirst: true,
          responsive: [
            {
              breakpoint: 850,
              settings: {
                dots: false,
                arrows: true,
                prevArrow: '.product_media .carousel-arrow-left',
                nextArrow: '.product_media .carousel-arrow-right',
              },
            },
          ],
        });

        $('.thumbs-slider').slick({
          slidesToShow: 6,
          slidesToScroll: 1,
          infinite: true,
          vertical: true,
          verticalSwiping: true,
          asNavFor: '.product_media',
          dots: false,
          arrows: true,
          focusOnSelect: true,
          slide: '.slider-t',
          prevArrow: '.thumbs-slider .carousel-arrow-top',
          nextArrow: '.thumbs-slider .carousel-arrow-bottom',
          responsive: [
            /*{
              breakpoint: 850,
              settings: 'unslick',
            },*/
            {
              breakpoint: 1720,
              settings: {
                slidesToShow: 5,
              },
            },
            {
              breakpoint: 1460,
              settings: {
                slidesToShow: 4,
              },
            },
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 3,
              },
            },
            {
              breakpoint: 1110,
              settings: {
                slidesToShow: 4,
              },
            },
            {
              breakpoint: 912,
              settings: {
                slidesToShow: 3,
              },
            },
          ],
        });
      }
    };

    this.setZoom = function (index, isSlide) {
      if (isSlide) {
        var element = document.getElementById('slider_cont_' + index);
        var panzoom = Panzoom(element, {
          canvas: false,
          maxScale: 4,
          pinchAndPan: true,
          panOnlyWhenZoomed: true,
          minScale: 1,
          exclude: ['.slick-dots'],
        });

        element.addEventListener('panzoomend', (event) => {
          panzoom.reset();
        });

        self.currentPanzzom = panzoom;
      }
    };
  }

  function Accordion() {
    $('.info-section .section-title', '.info-sections').on(
      'click',
      function (e) {
        var $section = $(this).closest('.info-section');
        var isOpen = $section.hasClass('open');

        $('.info-section.open').not($section).removeClass('open');
        $section.toggleClass('open');

        if (!isOpen) {
          var sectionTop = $section.offset().top;
          var viewportTop = $(window).scrollTop();
          var viewportHeight = $(window).height();

          if (
            sectionTop < viewportTop ||
            sectionTop + $section.outerHeight() > viewportTop + viewportHeight
          ) {
            $('html, body').animate(
              {
                scrollTop:
                  sectionTop - (viewportHeight - $section.outerHeight()) / 2,
              },
              200,
            );
          }
        }
      },
    );
  }

  function initializeFancybox() {
    Fancybox.bind('[data-fancybox="gallery"]', {
      Hash: false,
      Thumbs: false,
      compact: false,
      contentClick: 'iterateZoom',
      wheel: 'slide',
      Toolbar: {
        display: {
          left: [],
          middle: [],
          right: ['close'],
        },
      },
      Images: {
        Panzoom: {
          maxScale: 2,
          startScale: 2,
          contain: 'invert',
        },
      },
    });
  }

  var lightbox = new PhotoSwipeLightbox({
    gallery: '.pdp-product-pics-container',
    children: '.gallery',
    mouseMovePan: true,
    secondaryZoomLevel: 1,
    maxZoomLevel: 2,
    counter: false,
    pswpModule: PhotoSwipe,
  });
  lightbox.init();

  $(document).ready(function () {
    new slidePDP().init();
    new Accordion();
  });
})();
